<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!--        <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>-->
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <div class="main-icon-b" style="margin-right: 20px;">
              <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
              <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="c" dropdown>全部</el-dropdown-item>
                  <el-dropdown-item command="a">可用</el-dropdown-item>
                  <el-dropdown-item command="b">禁用</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <!--            <div class="block">
                          <el-date-picker
                              size="mini"
                              v-model="queryConditionForm.timeFrameArr"
                              type="datetimerange"
                              align="right"
                              unlink-panels
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              @change="handleConditionQuery"
                              :picker-options="pickerOptions">
                          </el-date-picker>
                        </div>-->

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleDbShowData">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)"
                             header-align="center">
              <template #default="{ row }">
                <!-- 特殊处理状态列（假设prop为'state'） -->
                <template v-if="col.prop === 'state'">
                  <el-tag :type="row.status === 1 ? 'success' : 'danger'"
                          size="small"
                          effect="light"
                          :class="'status-tag status-tag-' + row.status">
                    <i :class="row.status === 1 ? 'el-icon-success' : 'el-icon-error'"></i>
                    {{ row.status === 1 ? '启用' : '禁用' }}
                  </el-tag>
                </template>
                <!-- 其他列保持原样 -->
                <template v-else>
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148" v-if="$store.getters.hasPermission('system:expenseCategory:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleEditExpenseCateGory(scope.row)" size="mini" :disabled="scope.row.clinicId === 0">编辑</el-button>
                  <el-button
                      :disabled="scope.row.clinicId === 0"
                      :type="scope.row.status === 1 ? 'danger' : 'success'"
                      @click="handleStartOrDisabled(scope.row)"
                      size="mini"
                  >
                    {{ scope.row.status === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
            :title='addExpenseCateGoryForm.id == null ? "新增发票类别" : (showExpenseCateGoryDialogVisible ? "查看发票类别" : "修改发票类别")'
            :visible.sync="addExpenseCateGoryDialogVisible"
            :close-on-click-modal="false"
            width="700px"
            @close="handleCloseAddOnCredit"
            class="custom-form-dialog"
        >
          <el-form
              size="mini"
              :model="addExpenseCateGoryForm"
              ref="addExpenseCateGoryForm"
              :rules="addExpenseCateGoryFormRules"
              label-width="110px"
              label-position="right"
              :disabled="showExpenseCateGoryDialogVisible"
          >
            <!-- 第一行：编码 + 合约单位 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="编码：" prop="code">
                  <el-input
                      disabled
                      v-model="addExpenseCateGoryForm.code"
                      clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="适用对象:" prop="applyobject">
                  <el-select
                      v-model="addExpenseCateGoryForm.applyobject"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                  >
                    <el-option
                        v-for="item in applyobjectOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行：名称 + 状态 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="名称：" prop="name">
                  <el-input
                      v-model="addExpenseCateGoryForm.name"
                      @input="handleExpenseCateGoryForGetPy"
                      placeholder="请输入完整名称"
                      clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：" prop="status">
                  <el-select
                      v-model="addExpenseCateGoryForm.status"
                      placeholder="请选择状态"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="item in stateOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <!-- 拼音简码（单独一行） -->
                <el-form-item label="拼音简码：">
                  <el-input
                      v-model="addExpenseCateGoryForm.pycode"
                      placeholder="自动生成"
                      disabled
                      class="disabled-input"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收支类型：" prop="type">
                  <el-select
                      v-model="addExpenseCateGoryForm.type"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="item in incomeAndExpenditureTypeOptions"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>


            <!-- 备注（文本域） -->
            <el-form-item label="备注：">
              <el-input
                  type="textarea"
                  v-model="addExpenseCateGoryForm.remarks"
                  :rows="3"
                  placeholder="可输入额外说明信息"
                  resize="none"
                  show-word-limit
                  maxlength="200"
              />
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showExpenseCateGoryDialogVisible" size="mini" type="primary"
                       @click="handleAddExpenseCateGory">保存
            </el-button>
            <el-button :disabled="showExpenseCateGoryDialogVisible" size="mini" @click="handleCloseAddOnCredit">取消
            </el-button>
          </div>
        </el-dialog>

      </div>
    </div>

    <el-pagination
        class="fixed-pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>

<script>
import {pinyin} from "pinyin-pro";
import {getContuntList, getDeptList} from "@/api/reservation/reservation";
import {getDoctorList} from "@/api/scheduling/scheduling";
import {getOnCredit} from "@/api/reservation/onCredit";
import {addOnCredit, editOnCredit} from "@/api/reservation/outpatientCharge";
import dayjs from "dayjs";
import {withLoading} from "@/untils/loading";
import {
  addExpenseCategory,
  editExpenseCategory,
  getExpenseCategoryList,
  getExpenseCategoryPage
} from "@/api/managementMenu/expenseCategory";

export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      // 树菜单Props
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // str
      windowWidth: '', //右侧表格动态宽度
      searchValue: '',
      CatalogueName: '发票类别',
      DropDownedName: '全部',
      state: null,
      iconComes: 'el-icon-byj',
      queryConditionForm: {
        name: '',
        timeFrameArr: [
          dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
        ],
        status:null,
      },

      //模态框控制
      loading: false,
      addExpenseCateGoryDialogVisible: false,
      showExpenseCateGoryDialogVisible: false,
      incomeAndExpenditureTypeOptions: [{id: 1, label: '收入'}, {id: 2, label: '支出'}],
      //分页参数
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,

      applyobjectOptions: [{id: 0, label: '全部'}, {id: 1, label: '门诊'}, {id: 2, label: '住院'}],
      stateOption: [{id: 0, label: '禁用'}, {id: 1, label: '可用'}],
      doctorOptions: [],

      //表单验证
      addExpenseCateGoryFormRules: {
        applyobject: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        type: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        status: [
          {required: true, message: ' ', trigger: 'change'}
        ],
        name: [
          {required: true, message: ' ', trigger: 'blur'},
          {min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur'}
        ],
        code: [
          {required: true, message: ' ', trigger: 'blur'},
        ],
      },

      //表单容器
      addExpenseCateGoryForm: {
        id:null,
        code: this.$generateSixDigitCode(),
        name: '',
        applyobject: null,
        pycode: '',
        remarks: '',
        status: 1,
        type:null,
      },

      //表格容器
      tableData: [],

      //动态按钮
      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
        {add: "add", title: "新增", type: "warning",auth:'system:expenseCategory:add'},
      ],
      //侧边树
      elTree: [
        {label: '全部', path: '', title: '', icon: 'el-icon-news', children: [],},
      ],

      //动态列容器
      tableRows: [
        {name: "系统序号", prop: "id", type: ""},
        {name: "编码", prop: "code", type: ""}, {name: "名称", prop: "name", type: ""},
        {name: "有效状态", prop: "state", type: "", op: 'stateOption'},

        {
          name: "适用对象",
          prop: "applyobject",
          op: 'applyobjectOptions'
        },
        {name: "备注", prop: "remarks", type: ""},
      ],


      areaOption: [{id: 1, label: '省内'}, {id: 2, label: '省外'}, {id: 3, label: '进口'}],

      costTypeOptions:[],
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async getCostTypeOptions(){
      const res = await getExpenseCategoryList();
      this.costTypeOptions = res.data.map(item => {return{
        id: item.id,
        label: item.name,
        applyobject: item.applyobject
      }})
      this.$store.commit('preload/updatePreloadData', {
        key: 'getCostTypeOptions',
        data: this.costTypeOptions
      });
    },
    async handleConditionQuery() {
      try {
        const res = await getOnCredit({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',  // name为空时传空字符串
          startTime: this.queryConditionForm.timeFrameArr?.[0] || '',  // 使用可选链更安全
          endTime: this.queryConditionForm.timeFrameArr?.[1] || '',    // 使用可选链更安全
          state: this.state ?? null  // 使用空值合并运算符
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {
            return {
              ...item,
              createTime: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
              endTime: item.endTime ? dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
              beginTime: item.beginTime ? dayjs(item.beginTime).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          })
          await this.getContuntList();
        } else {
          this.$message.error("系统异常:请联系管理员")
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员")
      } finally {

      }
    },

    //修改
    async handleEditExpenseCateGory(row) {
      this.addExpenseCateGoryForm = {...row};
      this.addExpenseCateGoryDialogVisible = true;
    },

    //新增修改
    async handleAddExpenseCateGory() {
      try {
        await this.$refs.addExpenseCateGoryForm.validate();
      } catch (error) {
        this.$message.warning("请完善表单信息")
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        let res;
        if (!this.addExpenseCateGoryForm.id) {
          res = await addExpenseCategory(this.addExpenseCateGoryForm);
        } else {
          res = await editExpenseCategory(this.addExpenseCateGoryForm);
        }
        if (res.code === 200) {
          await this.getCostTypeOptions();
          this.handleCloseAddOnCredit();
          await this.loadData();
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    //合约单位下拉框
    async getContuntList() {
      if (this.contractUnitOption.length > 0) return;
      const res = await getContuntList();
      this.contractUnitOption = res.data.map(item => {
        return {id: item.id, label: item.name}
      })
    },

    //关闭模态框清空数据
    handleCloseAddOnCredit() {
      this.addExpenseCateGoryForm = Object.assign({}, this.$options.data.call(this).addExpenseCateGoryForm);
      this.$nextTick(() => {
        this.$refs.addExpenseCateGoryForm.clearValidate();
      });
      this.addExpenseCateGoryDialogVisible = false;
      this.showExpenseCateGoryDialogVisible = false;
    },

    //转拼音
    handleExpenseCateGoryForGetPy() {
      this.addExpenseCateGoryForm.pycode =
          pinyin(this.addExpenseCateGoryForm.name, {
            pattern: 'first',
            toneType: 'none',
            separator: ''
          }).toLocaleUpperCase();
    },

    //科室下拉框
    async getDeptList() {
      const res = await getDeptList()
      this.deptOptions = res.data.map(item => {
        return {id: item.id, label: item.deptName}
      })
    },

    //医生下拉框
    async getDoctorList() {
      const res = await getDoctorList()
      this.doctorOptions = res.data.map(item => {
        return {id: item.id, label: item.fullName}
      })
    },

    //启用禁用
    async handleStartOrDisabled(row) {
      try {
        // 确认弹框
        const confirmMessage = row.state === 1 ? `确定要禁用${row.name}吗？` : `确定要启用${row.name}吗？`;
        const confirmResult = await this.$confirm(confirmMessage, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).catch(() => {
          return false;
        });

        // 如果用户点击取消，直接返回
        if (!confirmResult) return;

        // 执行状态修改
        this.addExpenseCateGoryForm = {...row};
        this.addExpenseCateGoryForm.status = row.status === 1 ? 0 : 1;
        const res = await editExpenseCategory(this.addExpenseCateGoryForm);
        if (res.code === 200) {
          await this.loadData();
          this.$message.success(`修改${this.addExpenseCateGoryForm.name}状态成功`);
        } else {
          this.$message.error(`修改${this.addExpenseCateGoryForm.name}状态失败`);
        }
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作过程中发生错误');
      }
    },

    //双击查看的当前行信息
    handleDbShowData(row) {
      this.addExpenseCateGoryForm = row;
      this.addExpenseCateGoryDialogVisible = true;
      this.showExpenseCateGoryDialogVisible = true;
    },

    //表格字段映射
    safeGetMappedValue(col, row) {
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id === rawValue);
      return matched?.label || rawValue;
    },

    //数据源
    async loadData() {
      try {
        const res = await getExpenseCategoryPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',  // name为空时传空字符串
          status: this.queryConditionForm.status ?? null,  // name为空时传空字符串
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content;
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员")
      } finally {

      }
    },

    //侧边树(全部)按钮
    handleNodeClick(data, e) {
      this.searchValue = '';
      this.loadData()
    },

    //动态计算列宽
    columnWidth(col, list) {
      let prop = col.prop, lab = col.lab;
      let width = 40; // 设定一个最小值
      let maxlenStr = ""; // 最长字符串
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      // 表格自带的内边距(20px) 自调
      return width + 12; // 这里加了 12px
      function len(str) {
        // 实际分配长度可根据需要自行调整
        let length = 8;
        for (const char of str + "") {
          // 英文小写字符 8px
          if ("a" <= char && char <= "z") length += 8;
          // 英文大写字符 8px
          else if ("A" <= char && char <= "Z") length += 8;
          // 中文字符 28px
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
          // 其他 8px
          else length += 12;
        }
        return length;
      }
    },

    // 步骤
    async handClick(i) {
      switch (i) {
        case 0:
          await this.loadData()
          break;
        case 1:
          this.addExpenseCateGoryDialogVisible = true;
          break;
      }
    },

    //状态查询
    async handleCommand(command) {
      this.queryConditionForm.status = command === 'a' ? 1 : command === 'b' ? 0 : null;
      await this.loadData();
      this.DropDownedName = this.queryConditionForm.status === 1 ? '可用' : this.queryConditionForm.status === 0 ? '禁用' : '全部';
    },

    // 实时宽度
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 328;
    },

    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 20; // 增加边距缓冲
      const contentList = tableData.map(item => item?.[prop] ?? '');

      // 计算所有内容宽度（包括表头）
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
  }
}
</script>

<style lang="less" scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 190px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

.patient-dialog {
  .el-dialog {
    /* 改为动态高度控制 */
    max-height: 70vh !important;
    height: auto !important; /* 关键修改 */
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 15% !important; /* 上移对话框位置 */
    left: 50%;
    transform: translateX(-50%);
    margin: 0 !important;

    .el-dialog__header {
      height: 35px !important;
      padding: 5px 15px !important;
      flex-shrink: 0; /* 防止头部被压缩 */

      .el-dialog__title {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .el-dialog__body {
      flex: 1;
      padding: 8px !important;
      overflow: hidden; /* 外层隐藏滚动 */
      display: flex;
      flex-direction: column;
      min-height: 0; /* 关键修复：允许flex子项收缩 */

      .aform, .bform {
        flex: 1;
        overflow-y: auto; /* 只在表单容器内滚动 */
        margin-bottom: 5px;
        min-height: 0; /* 关键修复 */

        .el-tabs {
          height: 100%;
          display: flex;
          flex-direction: column;
          min-height: 0; /* 关键修复 */

          .el-tabs__content {
            flex: 1;
            overflow: visible; /* 禁用嵌套滚动 */
            padding: 5px;
          }
        }
      }
    }

    .el-dialog__footer {
      height: 40px !important;
      padding: 5px !important;
      flex-shrink: 0; /* 防止底部被压缩 */

      .el-button {
        padding: 7px 15px !important;
      }
    }
  }

  /* 小屏幕适配 */
  @media (max-height: 600px) {
    .el-dialog {
      max-height: 80vh !important;
      top: 10% !important;

      .el-dialog__body {
        padding: 5px !important;
      }
    }
  }
}

/* 极紧凑表单样式 */
/deep/ .el-form-item {
  margin-bottom: 8px !important;

  .el-form-item__label {
    padding-bottom: 0 !important;
    line-height: 20px !important;
    height: 20px !important;
  }

  .el-form-item__content {
    line-height: 20px !important;
  }
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

// 穿透
/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-icon-arrow-left:before {
  content: "\e67d";
  font-size: 18px;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-descriptions {
  font-size: 12px !important;
}

/deep/ .el-descriptions-item__container {
  display: flex !important;
  // align-items: center !important;
  padding-top: 12px !important;
}

/deep/ .el-descriptions-item__label:not(.is-bordered-label) {
  padding-left: 0;
  display: flex;
  justify-content: right;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

  }

  // main
  .main {
    width: 100%;
    margin-left: 8px;
    display: flex;
    justify-content: left;
    overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left
    .main-left {
      .custom-tree {
        max-height: 100%; /* 设置树形菜单的最大高度为父容器的100% */
        overflow-y: auto; /* 当内容超出设定高度时显示滚动条 */
      }

      /deep/ .el-tree-node__content {
        height: 40px;
        padding-left: 0 !important;
      }

      /deep/ .el-tree-node__label {
        font-size: 12px;
      }

      width: 10%;
      height: 100%;
    }

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // feet
  .feet {
    .addmessagesBox {
      .aform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }

      .bform {
        padding: 12px;
        margin-top: 12px;
        border: 1px solid #e7e7e7;
      }
    }

    // alert
    .messagesBox {
      .tabs {

        /deep/ .el-form-item__content {
          display: flex;

          span {
            font-size: 12px;
          }
        }

        .oneLine {
          width: 524px;
          // background-color: indianred;
        }
      }

      /deep/ .el-dialog__title {
        font-size: 12px;
      }

      /deep/ .el-table {
        font-size: 12px;
      }

    }
  }

}
</style>